import { root } from 'app/store/constants';

const TYPE_SWITCHER_EXPANDED_WIDTH = 1600; //px

export const isSwitcherCollapsedByAside = (
): boolean => {
    return root._innerWidth < TYPE_SWITCHER_EXPANDED_WIDTH;
};
